const NAMESPACE = 'FILTER_DATA';

const SET_CARRIER_ACTIVE = `${NAMESPACE}/SET_CARRIER_ACTIVE`;
const SET_CARRIERS_ACTIVE = `${NAMESPACE}/SET_CARRIERS_ACTIVE`;
const SET_FEATURE_ACTIVE = `${NAMESPACE}/SET_FEATURE_ACTIVE`;
const SET_TRAVEL_MODE_VALUE = `${NAMESPACE}/SET_TRAVEL_MODE_VALUE`;
const SET_TRAVEL_MODE_ONLY_ACTIVE = `${NAMESPACE}/SET_TRAVEL_MODE_ONLY_ACTIVE`;
const SET_ALLOW_NEARBY_ACTIVE = `${NAMESPACE}/SET_ALLOW_NEARBY_ACTIVE`;
const SET_DIRECT_ONLY_ACTIVE = `${NAMESPACE}/SET_DIRECT_ONLY_ACTIVE`;
const SET_DEPARTURE_TIMING_RANGE = `${NAMESPACE}/SET_DEPARTURE_TIMING_RANGE`;
const SET_ARRIVAL_TIMING_RANGE = `${NAMESPACE}/SET_ARRIVAL_TIMING_RANGE`;
const RESET_DEPARTURE_TIMING = `${NAMESPACE}/RESET_DEPARTURE_TIMING`;
const RESET_ARRIVAL_TIMING = `${NAMESPACE}/RESET_ARRIVAL_TIMING`;
const RESET_TRAVEL_MODES = `${NAMESPACE}/RESET_TRAVEL_MODES`;
const RESET_CARRIERS = `${NAMESPACE}/RESET_CARRIERS`;
const RESET_FEATURES = `${NAMESPACE}/RESET_FEATURES`;
const RESET_DIRECT_ONLY = `${NAMESPACE}/RESET_DIRECT_ONLY`;
const RESET_ALLOW_NEARBY = `${NAMESPACE}/RESET_ALLOW_NEARBY`;
const SET_SORT_TYPE = `${NAMESPACE}/SET_SORT_TYPE`;
const SET_NEW_FILTER_ID = `${NAMESPACE}/SET_NEW_FILTER_ID`;
const SET_STATION_ACTIVE = `${NAMESPACE}/SET_STATION_ACTIVE`;
const SET_STATION_ONLY_ACTIVE = `${NAMESPACE}/SET_STATION_ONLY_ACTIVE`;
const RESET_STATIONS = `${NAMESPACE}/RESET_STATIONS`;
const SET_BULK = `${NAMESPACE}/SET_BULK`;

export {
    RESET_ALLOW_NEARBY,
    RESET_ARRIVAL_TIMING,
    RESET_CARRIERS,
    RESET_DEPARTURE_TIMING,
    RESET_DIRECT_ONLY,
    RESET_FEATURES,
    RESET_STATIONS,
    RESET_TRAVEL_MODES,
    SET_ALLOW_NEARBY_ACTIVE,
    SET_ARRIVAL_TIMING_RANGE,
    SET_BULK,
    SET_CARRIERS_ACTIVE,
    SET_CARRIER_ACTIVE,
    SET_DEPARTURE_TIMING_RANGE,
    SET_DIRECT_ONLY_ACTIVE,
    SET_FEATURE_ACTIVE,
    SET_NEW_FILTER_ID,
    SET_SORT_TYPE,
    SET_STATION_ACTIVE,
    SET_STATION_ONLY_ACTIVE,
    SET_TRAVEL_MODE_ONLY_ACTIVE,
    SET_TRAVEL_MODE_VALUE,
};

export default NAMESPACE;
